import React from "react";
import { Box, Tooltip, CircularProgress } from "@mui/material";
import { STATUS_META } from "./statusColors";

/**
 * Small dot or animated spinner that visually anchors the urgency rank
 * for a row in the Requests list. Spinner is used for in-flight statuses
 * so the user knows the worker is actively doing something.
 */
const UrgencyBadge = ({ status }) => {
  const meta = STATUS_META[status] || { fg: "#9e9e9e", label: status || "Unknown" };
  const isSpinning = status === "PRECHECK_RUNNING" || status === "RUNNING";
  return (
    <Tooltip title={`${meta.label} (urgency ${meta.urgency ?? 0})`} arrow placement="right">
      <Box
        sx={{
          width: 18,
          height: 18,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isSpinning ? (
          <CircularProgress size={12} sx={{ color: meta.fg }} thickness={6} />
        ) : (
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: meta.fg,
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default UrgencyBadge;
